import { Component, OnInit } from '@angular/core';
// import { LoginService } from 'src/app/services/login.service';
// import { LoginPageVM } from 'src/app/viewModels/login-page-vm';
// import { RoleType } from 'src/app/serviceModels/Enums/roleType';
import * as AOS from 'aos';
import { CommonService } from 'src/app/services/common.service';
import { LogHandlerService } from 'src/app/services/log-handler.service';
import { HomeViewModel } from 'src/app/view-models/home-page.viewmodel';
import { BaseComponent } from '../base.component';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomePageComponent extends BaseComponent<HomeViewModel>implements OnInit {
  // viewModel: LoginPageVM = new LoginPageVM();
  // eyeDefault = 'default';
  

  constructor(commonService: CommonService, logService: LogHandlerService){
    super(commonService, logService);
    this.viewModel=new HomeViewModel();
   
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      // once: true,
      // mirror: false
    });
   }

  ngOnInit(): void {
    // this.getEnumsArray();
  }
  // login() {
  //   try {
  //     let resp = this.loginService.login(this.viewModel.loginPageVM)
  //     console.log(resp);
  //   } catch (error) {

  //   }
  // }

  // getEnumsArray() {
  //   this.viewModel.roleTypes = this.EnumToStringArray(RoleType);
  // }


  // togglePassword() {
  //   this.viewModel.hide = !this.viewModel.hide;
  //   if (this.eyeDefault == 'default') {
  //     this.eyeDefault = 'eyeChange';
  //   } else {
  //     this.eyeDefault = 'default';
  //   }
  //   return;
  // }


//Change Enum value from api to String
  EnumToStringArray(LicenseType: any) {
    const StringIsNumber = (value: any) => isNaN(Number(value)) === false;
    return Object.keys(LicenseType)
      .filter(StringIsNumber)
      .map((key) => LicenseType[key]);
  } 
  
}
